<template>
  <div id="loading-root" class="text-center">
    <!-- 沒有作用？？？ color="primary" -->
    <v-progress-circular
      indeterminate
      :color="$vuetify.theme.themes.light.primary"
      :size="148"
      :width="12"
    >
      請稍候...
    </v-progress-circular>
  </div>
</template>

<script>
export default {
  created() {
    // window.console.log(this.$route.query.questSysId)
  }
}
</script>

<style lang="scss" scoped>
.v-progress-circular {
  margin: 1rem;
}
#loading-root {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
